import {
  InvoicesStoreResponseDto,
  InvoicesTaxRulesResponseDto,
  CreateArTaxRulesRequestDto,
  GetArTaxRulesResponseDto,
  UpdateArTaxRulesRequestDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import getUrlWithParams from 'commons/utils/getUrlWithParams';
import {
  invoicesEndpoints,
  invoicesTags,
  GET_STORE_INVOICES_URL,
  GET_TAX_RULES_URL,
  CREATE_AR_TAX_RULES_URL,
  GET_AR_TAX_RULES_URL,
  UPDATE_AR_TAX_RULES_URL,
  DELETE_AR_TAX_RULES_URL,
} from './config';

export const invoicesApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [
      invoicesTags.storeInvoices,
      invoicesTags.taxRules,
      invoicesTags.arTaxRules,
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [invoicesEndpoints.getStoreInvoices]: builder.query<
        InvoicesStoreResponseDto,
        void
      >({
        query: () => ({
          method: 'GET',
          url: GET_STORE_INVOICES_URL,
        }),
        providesTags: [invoicesTags.storeInvoices],
      }),
      [invoicesEndpoints.getTaxRules]: builder.query<
        InvoicesTaxRulesResponseDto[],
        { variantId: string }
      >({
        query: ({ variantId }) => ({
          method: 'GET',
          url: GET_TAX_RULES_URL,
          params: { variantId },
        }),
        providesTags: [invoicesTags.taxRules],
      }),
      [invoicesEndpoints.createArTaxRules]: builder.mutation<
        void,
        CreateArTaxRulesRequestDto
      >({
        query: (data) => ({
          method: 'POST',
          url: CREATE_AR_TAX_RULES_URL,
          data,
        }),
        invalidatesTags: [invoicesTags.arTaxRules, invoicesTags.taxRules],
      }),
      [invoicesEndpoints.getArTaxRules]: builder.query<
        GetArTaxRulesResponseDto,
        void
      >({
        query: () => ({
          method: 'GET',
          url: GET_AR_TAX_RULES_URL,
        }),
        providesTags: [invoicesTags.arTaxRules],
      }),
      [invoicesEndpoints.updateArTaxRules]: builder.mutation<
        void,
        { id: string; payload: UpdateArTaxRulesRequestDto }
      >({
        query: ({ id, payload }) => ({
          method: 'PUT',
          url: getUrlWithParams(UPDATE_AR_TAX_RULES_URL, { id }),
          data: payload,
        }),
        invalidatesTags: [invoicesTags.arTaxRules, invoicesTags.taxRules],
      }),
      [invoicesEndpoints.deleteArTaxRules]: builder.mutation<
        void,
        { id: string }
      >({
        query: ({ id }) => ({
          method: 'DELETE',
          url: getUrlWithParams(DELETE_AR_TAX_RULES_URL, { id }),
        }),
        invalidatesTags: [invoicesTags.arTaxRules, invoicesTags.taxRules],
      }),
    }),
  });

export const {
  useGetStoreInvoicesQuery,
  useGetTaxRulesQuery,
  useCreateArTaxRulesMutation,
  useGetArTaxRulesQuery,
  useUpdateArTaxRulesMutation,
  useDeleteArTaxRulesMutation,
} = invoicesApi;
